import { combineReducers } from "redux";

const programme = (state = {}, action) => {
  switch (action.type) {
    case "SET_SELECTED_PROGRAMME_DETAILS":
      return action.details;
    default:
      return state;
  }
};

const details = (state = {}, action) => {
  switch (action.type) {
    case "ADD_REPORT_DETAILS":
      return { ...state, [action.key]: action.data };
    case "SET_DETAILS_LOADING":
      return { ...state, loading: action.loading };
    case "SET_DETAILS_ERROR":
      return { ...state, error: action.error };
    default:
      return state;
  }
};

const staffworkers = (state = [], action) => {
  switch (action.type) {
    case "SET_REPORT_STAFFWORKERS":
      return action.staffworkers;
    default:
      return state;
  }
};

const list = (state = [], action) => {
  switch (action.type) {
    case "SET_REPORT_LIST":
      return action.reports;
    default:
      return state;
  }
};

const error = (state = "", action) => {
  switch (action.type) {
    case "SET_REPORT_ERROR":
      return action.error;
    default:
      return state;
  }
};

const type = (state = "Regular Support", action) => {
  switch (action.type) {
    case "SET_REPORT_TYPE":
      return action.reportType;
    default:
      return state;
  }
};

const loading = (state = false, action) => {
  switch (action.type) {
    case "SET_REPORT_LOADING":
      return action.loading;
    default:
      return state;
  }
};

const table = (
  state = {
    loading: false,
    error: "",
    query: "",
    programmeID: null,
  },
  action
) => {
  switch (action.type) {
    case "SET_TABLE_LOADING":
      return { ...state, loading: action.loading };
    case "SET_TABLE_LOADING_MORE":
      return { ...state, loadingMore: action.loadingMore };
    case "SET_TABLE_404":
      return { ...state, is404: action.is404 };
    case "SET_TABLE_ERROR":
      return { ...state, error: action.error };
    case "SET_TABLE_SEARCH_QUERY":
      return { ...state, query: action.query };
    case "SET_SELECTED_PROGRAMME_ID":
      return { ...state, programmeID: action.programmeID };
    default:
      return state;
  }
};

export default combineReducers({
  programme,
  staffworkers,
  details,
  loading,
  list,
  type,
  error,
  table,
});
